"use client"

import { ArrowBigLeftDash } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `ArrowBigLeftDashIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const ArrowBigLeftDashIcon = component(Icon)({ as: ArrowBigLeftDash })
